import type { DevicePreset, LoadUnit } from '@brt/shared-types'

export const DEVICE_PRESETS: readonly DevicePreset[] = [
  {
    id: 'dev-raspberry-pi-4',
    name: 'Raspberry Pi 4',
    category: 'Single Board Computer',
    loadValue: 3,
    loadUnit: 'W' as LoadUnit,
    voltage: 5,
    description: 'Raspberry Pi 4 Model B under typical load',
  },
  {
    id: 'dev-arduino-uno',
    name: 'Arduino Uno',
    category: 'Microcontroller',
    loadValue: 45,
    loadUnit: 'MA' as LoadUnit,
    voltage: 5,
    description: 'Arduino Uno Rev3 active mode',
  },
  {
    id: 'dev-esp32',
    name: 'ESP32',
    category: 'Microcontroller',
    loadValue: 240,
    loadUnit: 'MA' as LoadUnit,
    voltage: 3.3,
    description: 'ESP32-WROOM-32 WiFi active transmit',
  },
  {
    id: 'dev-laptop',
    name: 'Laptop',
    category: 'Computing',
    loadValue: 65,
    loadUnit: 'W' as LoadUnit,
    voltage: 19,
    description: 'Typical 15" laptop under normal use',
  },
  {
    id: 'dev-led-strip-1m',
    name: 'LED Strip (1m)',
    category: 'Lighting',
    loadValue: 1.2,
    loadUnit: 'A' as LoadUnit,
    voltage: 12,
    description: 'Standard 5050 SMD LED strip, 1 meter, white',
  },
  {
    id: 'dev-led-bulb',
    name: 'LED Bulb (10W)',
    category: 'Lighting',
    loadValue: 10,
    loadUnit: 'W' as LoadUnit,
    description: 'Standard 10W LED light bulb (800 lumens equiv.)',
  },
  {
    id: 'dev-wifi-router',
    name: 'WiFi Router',
    category: 'Networking',
    loadValue: 12,
    loadUnit: 'W' as LoadUnit,
    voltage: 12,
    description: 'Typical home WiFi router (802.11ac)',
  },
  {
    id: 'dev-4g-modem',
    name: '4G Modem',
    category: 'Networking',
    loadValue: 2,
    loadUnit: 'A' as LoadUnit,
    voltage: 5,
    description: 'USB 4G/LTE modem under active transfer',
  },
  {
    id: 'dev-cpap',
    name: 'CPAP Machine',
    category: 'Medical',
    loadValue: 30,
    loadUnit: 'W' as LoadUnit,
    voltage: 24,
    description: 'CPAP machine with humidifier, typical pressure',
  },
  {
    id: 'dev-portable-fridge',
    name: 'Portable Fridge',
    category: 'Appliance',
    loadValue: 5,
    loadUnit: 'A' as LoadUnit,
    voltage: 12,
    description: '12V compressor portable fridge/freezer, cycling',
  },
  {
    id: 'dev-smartphone',
    name: 'Smartphone Charging',
    category: 'Mobile',
    loadValue: 10,
    loadUnit: 'W' as LoadUnit,
    voltage: 5,
    description: 'Smartphone fast charging (USB-C PD)',
  },
  {
    id: 'dev-usb-fan',
    name: 'USB Fan',
    category: 'Cooling',
    loadValue: 0.5,
    loadUnit: 'A' as LoadUnit,
    voltage: 5,
    description: 'Small USB desk fan, 5V',
  },
] as const

export const DEVICE_CATEGORIES = [...new Set(DEVICE_PRESETS.map((p) => p.category))] as string[]

export function searchDevicePresets(query: string, category?: string): DevicePreset[] {
  const q = query.toLowerCase().trim()
  return DEVICE_PRESETS.filter((p) => {
    const matchesCategory = category ? p.category === category : true
    const matchesQuery = q === '' || p.name.toLowerCase().includes(q) || p.description.toLowerCase().includes(q)
    return matchesCategory && matchesQuery
  })
}
